class UspBanner extends HTMLElement {
  constructor () {
    super()

    this.calculateHeight()

    this.setupListeners()
  }

  setupListeners () {
    window.addEventListener('resize', this.onResize.bind(this))
    document.addEventListener(
      'shopify:section:load',
      this.calculateHeight.bind(this)
    )
  }

  onResize () {
    this.calculateHeight()
  }

  calculateHeight () {
    document.documentElement.style.setProperty(
      '--UspBanner_Height',
      `${this.offsetHeight}px`
    )
  }
}

customElements.define('usp-banner', UspBanner)
